<div class="puntos-venta-wapper-mobile">
    <app-puntos-venta-list></app-puntos-venta-list>
</div>